import parser from "html-react-parser";
import { MutableRefObject } from "react";
import { handleSubtitleFontSize } from "@/utils/BlockTextImage";

type Content = {
  type: string;
  text: string;
  isSubtitleHtag?: boolean;
};

export default function renderContent(
  i: number,
  title: string,
  content: Content,
  styles,
  subtitleFontSizeStyle,
  isHero: boolean,
  sectionName: string,
  separatorRef: MutableRefObject<any>
) {
  const { type, text } = content;
  switch (type) {
    case "text":
      return (
        <p
          key={title + i}
          className={`${sectionName}--contents ${styles._content_text}${
            isHero ? " hero-text" : " " + sectionName + "-text"
          }`}
        >
          {parser(text)}
        </p>
      );

    case "subtitles":
      if (content.isSubtitleHtag) {
        return (
          <h3
            key={title + i}
            className={`${sectionName}--contents ${
              styles._content_subtitle
            } ${handleSubtitleFontSize(subtitleFontSizeStyle, styles)}${
              isHero ? " hero-text" : " " + sectionName + "-text"
            }`}
          >
            {parser(text)}
          </h3>
        );
      }
      return (
        <p
          key={title + i}
          className={`${sectionName}--contents ${styles._content_subtitle}${
            isHero ? " hero-text" : " " + sectionName + "-text"
          }`}
        >
          {parser(text)}
        </p>
      );

    case "separator":
      return (
        <div
          ref={separatorRef}
          key={title + i}
          className={`${sectionName}--separator ${styles._separator}`}
        ></div>
      );
  }
}
